.title {
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 0.875rem;
  text-transform: uppercase;
}

.chipRow {
  margin-left: -11px;
}

.chip {
  margin: 4px !important;
  width: fit-content !important;
}
